import React from 'react';
import { sharedPluginStateHookMigratorFactory, useSharedPluginState, useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { SortingIcon } from '@atlaskit/editor-common/table';
var useSharedState = sharedPluginStateHookMigratorFactory(function (api) {
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['editorViewMode'], function (states) {
      var _states$editorViewMod;
      return {
        mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
      };
    }),
    mode = _useSharedPluginState.mode;
  return {
    mode: mode
  };
}, function (api) {
  var _useSharedPluginState2 = useSharedPluginState(api, ['editorViewMode']),
    editorViewModeState = _useSharedPluginState2.editorViewModeState;
  return {
    mode: editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode
  };
});
export var SortingIconWrapper = function SortingIconWrapper(props) {
  var _useSharedState = useSharedState(props.api),
    mode = _useSharedState.mode;
  if (mode === 'edit') {
    return null;
  }
  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React.createElement(SortingIcon, props);
};